import routeConstant from './RouteConstant'

export default
  {
  [routeConstant.MAIN]: 'card',
  [routeConstant.BUY_CARD]: 'add_card',
  [routeConstant.CARD_DEPOSIT]: 'deposit',
  [routeConstant.CARD_WITHDRAW]: 'withdraw',
  [routeConstant.CARD_APPLY_ORDER_DETAIL]: 'card_apply_order_detail',
  [routeConstant.CARD_HOME]: 'card',
  [routeConstant.CARD_BILL_LIST]: 'card_bill_list',
  [routeConstant.CARD_MANAGEMENT]: 'card_management',
  [routeConstant.CARD_APPLY]: 'card_apply',
  [routeConstant.CARD_APPLY_ORDER]: 'card_apply_order',
  [routeConstant.CARD_APPLY_LIST]: 'card_apply_list',
  [routeConstant.ASSETS_TRANS_LIST]: 'assets_trans_list',
}